<div *ngIf="isDesktop()"id="skip_to_main_content_id"  class="skipToMainContent" (click)="scrollToMainContainer()">
  <a *ngIf="!isHome()" href="javascript:void(0)">{{globalContent.text.skipToMainContent}}</a>
  <a *ngIf="isHome()" href="javascript:void(0)">{{globalContent.text.skipToSignOn}}</a>
</div>